import { RouteErrorBoundary } from "src/components/ErrorBoundary/RouteErrorBoundary.tsx";
import { CreateLayoutV2 } from "src/framework/createV2/CreateLayoutV2.tsx";
import { queryClient } from "src/lib/react-query.tsx";
import { resourceFormConfigQuery } from "src/system/resourceFormConfigQuery.ts";
import { formTranslationsQuery } from "src/system/formTranslationsQuery.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export type CreateCreateLayoutProps = {
  resource: string;
  layoutForm?: boolean;
};

export function createCreateLayoutV2({
  resource,
  layoutForm,
}: CreateCreateLayoutProps) {
  const Component = () => {
    return <CreateLayoutV2 layoutForm={layoutForm} resource={resource} />;
  };

  const ErrorBoundary = RouteErrorBoundary;

  const loader = async () => {
    if (layoutForm) {
      // fetch in parallel
      await Promise.all([
        queryClient.ensureQueryData(
          resourceFormConfigQuery({
            resource: resource,
            action: FormAction.Create,
          }),
        ),
        queryClient.ensureQueryData(
          formTranslationsQuery({
            resource,
            action: FormAction.Create,
          }),
        ),
      ]);
    }

    return null;
  };

  return {
    Component,
    ErrorBoundary,
    loader,
  };
}
